// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2chip","content":"styles_content__178VP","selectAll":"styles_selectAll__2FfA5"};